import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { TrackingInfo } from 'src/app/modules/crm/dashboard/entities/tracking-info';
import { InvoicesService } from 'src/app/modules/pos/invoices/services/invoices.service';
import { UtilsService } from 'core/utils/utils.service';

@Component({
  selector: 'app-tracking-numbers',
  templateUrl: './tracking-numbers.component.html',
  styleUrls: ['./tracking-numbers.component.scss'],
  standalone: false
})
export class TrackingNumbersComponent implements OnInit {
  appStrings: AppLocalization = {} as AppLocalization;
  trackingNumberList: TrackingInfo[] = [];
  orderNumber = '';
  displayedColumns = [
    'trackingNumber',
    'carrier',
    'goTo'
  ];

  private specialCarriers = ['UPS', 'FEDEX'];

  constructor(
    public dialogRef: MatDialogRef<TrackingNumbersComponent>,
    private appInfoService: AppInfoService,
    private invoicesService: InvoicesService,
    private utilsService: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.trackingNumberList = this.data.orderTrackingList;
    this.orderNumber = this.data.orderNumber;
  }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
  }

  close(): void {
    this.dialogRef.close();
  }

  openExternalTracking(trackingDetails: TrackingInfo) {
    // clone object to prevent UI changes
    const currentTracking = { ...trackingDetails };
    this.specialCarriers.forEach(specialCarrier => {
      if (trackingDetails.carrier.toUpperCase().includes(specialCarrier)) {
        currentTracking.carrier = specialCarrier;
      }
    });
    this.invoicesService.trackOrder(currentTracking);
    this.utilsService.copyTextToClipboard(currentTracking.trackingNumber);
  }
}
